/**
 * Pretty product URL → canonical database slug.
 * Used by App.js routes and any SEO helper that needs the reverse map.
 */
export const PRETTY_TO_SLUG = {
  "banking-software": "bank-reconciliation-suite",
  "hotel-management": "hotel-management-system",
  "hospital-management": "hospital-clinic-hms",
  "school-erp": "school-college-erp",
  "mlm-software": "mlm-direct-selling",
  "home-automation": "home-automation-software",
  "lms": "learning-management-system",
  "manufacturing-erp": "manufacturing-erp",
  "restaurant-pos": "restaurant-pos",
  "property-management": "property-management-system",
  "hr-payroll": "hr-payroll-suite",
  "logistics-software": "logistics-fleet",
};

export const SLUG_TO_PRETTY = Object.fromEntries(
  Object.entries(PRETTY_TO_SLUG).map(([k, v]) => [v, k])
);
